import React from 'react';
import Notifications from 'react-notification-system-redux';

export default class Notifier {

    constructor( store ){

        if( !store )
            throw new Error("Notifier requires the store to work");
        this.store = store;
    }

    warning= ( message, icon = "fa fa-info" )=>{
        this.store.dispatch( Notifications.warning({
            title: <i className={icon}/>,
            message: message,
        }));
    };

    error= ( message, icon = "fa fa-exclamation-triangle" )=>{
        this.store.dispatch( Notifications.error({
            title: <i className={icon}/>,
            message: message,
        }));
    };

    success= ( message, icon = "fa fa-check" )=>{
        this.store.dispatch( Notifications.success({
            title: <i className={icon}/>,
            message: message,
        }));
    }
}



// WEBPACK FOOTER //
// ./src/App/services/Notifier/index.js